import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import MuiListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";
import { appConfig } from "../../appConfig";

export const DRAWER_WIDTH = 240; // in pixels

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const DrawerHeader = styled.div`
  background-color: ${({ theme }) =>
    appConfig.theme.logoBackgroundColor || theme.palette.background.default};
`;

export const LogoContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => theme.spacing(10)};
`;

export const LogoImage = styled.img`
  max-height: 40px;
  max-width: 224px;
`;

export const Drawer = styled(MuiDrawer)`
  display: flex;
  flex-shrink: 0;

  & .MuiDrawer-paper {
    width: ${DRAWER_WIDTH}px;
    overflow: hidden;
  }
`;

export const DrawerMenuList = styled(List)`
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing(0)};
`;

export const IconContainer = styled.span`
  display: flex;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const VirtualDatacenter = styled(MuiListItem)`
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.palette.divider};
`;

export const SectionName = styled(MuiListItem)`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  background-color: ${({ theme }) => theme.palette.secondary.main};
  min-height: ${({ theme }) => theme.spacing(5)};
`;

export const SectionNameText = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ListItem = styled.li`
  padding: 0;
`;

export const Link = styled(RouterLink)`
  padding: ${({ theme }) => theme.spacing(1, 2)};
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  color: ${({ theme }) => theme.palette.text.primary};
  width: 100%;
`;

export const MenuFooter = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(15)};
`;
